import { backupApi } from '../api/backupApi'

export const triggerBackup = async () => {
  try {
    const response = await backupApi.triggerBackup()
    return response.data.success
  } catch (error) {
    console.error(`Error triggering backup: `, error)
    throw error
  }
}
